module.exports = __webpack_public_path__ + "static/media/Doksi.03561a77.svg";